import { useEffect, useMemo, useState } from "react";
import Slider from "react-slick";
import { getTeacher } from "../../../services/services";
import ReadMore from "./ReadMore";

const Team = () => {
  const [teacherList, setTeacherList] = useState([]);

  // Ambil data teacher
  const fetchTeacher = async () => {
    try {
      const data = await getTeacher();
      const shuffledData = [...data].sort(() => Math.random() - 0.5);
      setTeacherList(shuffledData);
    } catch (error) {
      console.error("Gagal mengambil data teacher", error);
    }
  };

  useEffect(() => {
    fetchTeacher();
  }, []);

  const settings = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay: true,
    swipeToSlide: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 992,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 576,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const team = [
    {
      id_teacher: 46,
      name: "Nursusilawaty",
      achievement: "Graduate from Universitas Hasanuddin 7+ years experience teaching English, Best Graduate of Social Science, Universitas Hasanuddin (2021)",
    },
    {
      id_teacher: 8,
      name: "Abdurrobbi",
      achievement: "6 years experiences teaching IELTS & General English",
    },
    {
      id_teacher: 26,
      name: "Afkari",
      achievement: "Graduate from Yogyakarta State University 3+ years experience teaching English, High Achieving Student in Specialized Field (2022), High Achieving Student in Reasoning-Based Disciplines (2021), Awardee, Indonesian International Student Mobility Award (2021)",
    },
    {
      id_teacher: 42,
      name: "Aga",
      achievement: "Graduate from State University of Surabaya, 4+ years experience teaching English, Student Representative, LAMDIK International Accreditation (2025), 1st Winner, English Week XXIX Essay Competition (2024), Multiple Winner, English Speech & Essay Competitions, Most Outstanding Student, State University of Surabaya (2023)",
    },
    {
      id_teacher: 39,
      name: "Tanjung",
      achievement: "",
    },
    {
      id_teacher: 24,
      name: "Alfin",
      achievement: "Graduate from Universitas Sumatera Utara, 16 years experience teaching General English & IELTSArea Director, Toastmasters International (2022-2023), 1st Place Area H2 Speech Contest (2021), 2nd Place Area M2 Speech Contest (2025), Speech Judge in various school competitions in Medan",
    },
    {
      id_teacher: 31,
      name: "Naomi",
      achievement: "",
    },
    {
      id_teacher: 34,
      name: "Anggi",
      achievement: "Graduate from Universitas Padjadjaran (English Linguistics), 10+ years experience teaching English, English Academic Manager (2023-Present), TKT Cambridge Certified Teacher (Modules 1-3)",
    },
    {
      id_teacher: 43,
      name: "Ben",
      achievement: "Graduate from Universitas Kristen Satya Wacana – Salatiga, IELTS Overall Band 8.0 (2025), Head of Public Relations, Creative Talents (2019), Student Companion, ACICIS PIBBI Program (2019-2020)",
    },
    {
      id_teacher: 37,
      name: "Gloria",
      achievement: "Graduate from Tomsk State Pedagogical University 5 years experience teaching IELTS & General English",
    },
    {
      id_teacher: 28,
      name: "Danny",
      achievement: "Graduate from As-Syafi’iyah Islamic University, Jakarta & Diploma in TESOL – ELS Malaysia, Kuala Lumpur, 12+ years experience teaching English, TESOL Certified Instructor, Cambridge TKT Certified (Modules 1, 2 & Young Learners), Researcher, Global Annual Youth Center for Research (2025–2026)",
    },
    {
      id_teacher: 40,
      name: "Erry",
      achievement: "",
    },
    {
      id_teacher: 32,
      name: "Firsty",
      achievement: "",
    },
    {
      id_teacher: 22,
      name: "Wulan",
      achievement: "",
    },
    {
      id_teacher: 38,
      name: "Damara",
      achievement: "Graduate from Sanata Dharma University (Master of English Education), 9+ years experience teaching IELTS, TOEFL, General English",
    },
    {
      id_teacher: 14,
      name: "Irma",
      achievement: "",
    },
    {
      id_teacher: 19,
      name: "Ivan",
      achievement: "Graduate from Federation University – Melbourne, 8+ years experience teaching IELTS & General English, LPDP Academic Writing Instructor (2023-2024)",
    },
    {
      id_teacher: 36,
      name: "Arif",
      achievement: "Graduate from UIN Sunan Gunung Djati Bandung, 13+ years experience teaching English, TKT Cambridge Certified Teacher (2025), Best English Instructor, Language Center UIN SGD (2019-2021), Best English Speaker, ASNC (2014)",
    },
    {
      id_teacher: 33,
      name: "Maryo",
      achievement: "Graduate from SIM University & Binus Online Learning, 2 years experience teaching IELTS and General English, First Class Honours, SIM University, Summa Cum Laude, Binus Online Learning",
    },
    {
      id_teacher: 44,
      name: "Fadhilah",
      achievement: "",
    },
    {
      id_teacher: 9,
      name: "Wening",
      achievement: "Graduate from Universitas Lampung (English Education), 5+ years experience teaching IELTS, TOEFL & General English",
    },
    {
      id_teacher: 18,
      name: "Ricky",
      achievement: "6 years Experience teaching IELTS & General English,Trainer of Public speaking",
    },
    {
      id_teacher: 30,
      name: "Reza",
      achievement: "Graduate from Universitas Sumatera Utara - Medan,5 years experience teaching IELTS & General English",
    },
    {
      id_teacher: 21,
      name: "Fani",
      achievement: "",
    },
  ]

  const teamMap = useMemo(() => {
    const map = {};
    team.forEach((item) => {
      map[item.id_teacher] = item;
    });
    return map;
  }, []);

  return (
    <section className="team section-padding" id="instructor">
      <div className="container">
        <div className="row mb-5">
          <div className="col-12">
            <div className="section-heading text-center">
              <h2 className="font-lg">Instruktur Kami</h2>
              <p className="">Instruktur berpengalaman yang siap membimbing perjalanan bahasa Inggrismu dengan metode efektif dan menyenangkan.</p>
              <p className="">
                <a 
                  href="/instructor" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-danger btn-sm"
                >
                  Lihat Semua Instruktur
                </a> 
              </p>           
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <Slider {...settings}>
              {teacherList.map((data) => {
                const teacher = teamMap[data.id_teacher];
                return (
                  <div key={data.id_teacher} className="px-2">
                    <div className="team-item team-item-4 mb-70 h-teacher">
                      <div className="mt-1">
                        <img
                          src={data.foto}
                          alt={data.nama_lengkap}
                          className="img-fluid crop"
                        />
                      </div>

                      <div className="team-content">
                        <div className="team-info">
                          <h5 className="mt-2">{data.nama_lengkap}</h5>
                          {/* <ReadMore text={teacher?.achievement || ""} maxWords={4} /> */}
                          <p>English Teacher</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </Slider>
          </div>
        </div>
      </div>      
    </section>
  );
};

export default Team;